import { useOpenRequestMemo } from '@hooks/Services';
import { Error, Loading } from '@organisms/Feedbacks';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { MemoForm } from '../Forms';
import { dateFormat } from '../Utils';

const defaultTimestamp = new Date().getTime();

const DetailMemoList = () => {
    const id:any = useParams().id;
    const [timestamp, setTimestamp] = useState(defaultTimestamp);
    const listData = useOpenRequestMemo.useAllListData({
        swOpenRequestId: id,
        timestamp: timestamp
    });
    const { data, error, loading } = listData;
    const memoData = data || [];
    const afterSbumit = () => {
        setTimestamp(new Date().getTime());
    };

    return (
        <WrapperWithStyled className='detailTableWrapper'>
            {loading && <Loading />}
            {error && <Error />}
            {!loading && !error &&
                <TableWithStyled className='table table-bordered table-primary'>
                    <TableHeadWithStyled>
                        <TableRowWithStyled>
                            <TableThWithStyled className='cell-20per'>登録日</TableThWithStyled>
                            <TableThWithStyled className='cell-20per'>登録者</TableThWithStyled>
                            <TableThWithStyled className='cell-60per'>内容</TableThWithStyled>
                        </TableRowWithStyled>
                    </TableHeadWithStyled>
                    <TableBodyWithStyled>
                        {memoData.map((memo: any, index: number) => {
                            return (
                                <TableRowWithStyled key={index}>
                                    <TableTdWithStyled>{dateFormat(memo.createDate)}</TableTdWithStyled>
                                    <TableTdWithStyled>{memo.createUser}</TableTdWithStyled>
                                    <TableTdWithStyled>{memo.memoContent}</TableTdWithStyled>
                                </TableRowWithStyled>
                            );
                        })}
                        <TableRowWithStyled>
                            <TableTdWithStyled colSpan={3}>
                                <MemoForm afterSbumit={afterSbumit} />
                            </TableTdWithStyled>
                        </TableRowWithStyled>
                    </TableBodyWithStyled>
                </TableWithStyled>
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    & td {
        background-color: white;
    }
`
const TableWithStyled = styled.table`
`
const TableHeadWithStyled = styled.thead`
`
const TableBodyWithStyled = styled.tbody`
`
const TableRowWithStyled = styled.tr`
`
const TableThWithStyled = styled.th`
`
const TableTdWithStyled = styled.td`
`

export default DetailMemoList;